import { render, staticRenderFns } from "./InvitationsList.vue?vue&type=template&id=10d72be4&scoped=true&"
import script from "./InvitationsList.vue?vue&type=script&lang=js&"
export * from "./InvitationsList.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsList.vue?vue&type=style&index=0&id=10d72be4&lang=scss&scoped=true&"
import style1 from "./InvitationsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d72be4",
  null
  
)

export default component.exports